import React from 'react';
import SectionCard from '../controls/SectionCard';
import Slider from '../controls/Slider';

const TextSpacingSection = ({ model, disabled }) => {
  const lineHeight = model.mixed('lineHeight');
  const letterSpacing = model.mixed('letterSpacing');
  const paddingX = model.mixed('paddingX');
  const paddingY = model.mixed('paddingY');

  return (
    <SectionCard title="Spacing">
      <Slider
        label="Line height"
        min={0.8}
        max={2.5}
        step={0.05}
        value={lineHeight.kind === 'mixed' ? 1.2 : lineHeight.value}
        mixed={lineHeight.kind === 'mixed'}
        onChange={(value) => model.applyToSelection({ lineHeight: value }, 'commitOnRelease', 'line-height')}
        onCommit={() => model.commitPending('line-height')}
        disabled={disabled}
      />
      <Slider
        label="Letter spacing"
        min={-2}
        max={20}
        step={0.5}
        value={letterSpacing.kind === 'mixed' ? 0 : letterSpacing.value}
        mixed={letterSpacing.kind === 'mixed'}
        onChange={(value) => model.applyToSelection({ letterSpacing: value }, 'commitOnRelease', 'letter-spacing')}
        onCommit={() => model.commitPending('letter-spacing')}
        disabled={disabled}
      />
      <Slider
        label="Padding X"
        min={0}
        max={48}
        step={1}
        value={paddingX.kind === 'mixed' ? 0 : paddingX.value}
        mixed={paddingX.kind === 'mixed'}
        onChange={(value) => model.applyToSelection({ paddingX: value }, 'commitOnRelease', 'padding-x')}
        onCommit={() => model.commitPending('padding-x')}
        disabled={disabled}
      />
      <Slider
        label="Padding Y"
        min={0}
        max={48}
        step={1}
        value={paddingY.kind === 'mixed' ? 0 : paddingY.value}
        mixed={paddingY.kind === 'mixed'}
        onChange={(value) => model.applyToSelection({ paddingY: value }, 'commitOnRelease', 'padding-y')}
        onCommit={() => model.commitPending('padding-y')}
        disabled={disabled}
      />
    </SectionCard>
  );
};

export default TextSpacingSection;
